import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Styles from "../styles/Analytics.module.css";
import { formatNumber } from "../utils/analyticsUtils";

export const StatCard = ({ icon, label, value, hint, color, onClick }) => {
  const content = (
    <>
      <span
        className={Styles.statIcon}
        style={{ color, backgroundColor: `${color}1f` }}
      >
        <FontAwesomeIcon icon={icon} />
      </span>
      <span className={Styles.statBody}>
        <span className={Styles.statValue}>{value}</span>
        <span className={Styles.statLabel}>{label}</span>
        {hint && <span className={Styles.statHint}>{hint}</span>}
        {onClick && <span className={Styles.statLink}>View details →</span>}
      </span>
    </>
  );

  if (onClick) {
    return (
      <button
        type="button"
        className={`${Styles.statCard} ${Styles.statCardClickable}`}
        onClick={onClick}
      >
        {content}
      </button>
    );
  }

  return <div className={Styles.statCard}>{content}</div>;
};

export const ChartCard = ({ title, subtitle, total, totalLabel, children }) => (
  <div className={Styles.card}>
    <div className={Styles.cardHeader}>
      <div>
        <h3 className={Styles.cardTitle}>{title}</h3>
        {subtitle && <p className={Styles.cardSubtitle}>{subtitle}</p>}
      </div>
      {total !== undefined && (
        <span className={Styles.cardTotal}>
          {total}
          {totalLabel && <small>{totalLabel}</small>}
        </span>
      )}
    </div>
    <div className={Styles.chartWrapper}>{children}</div>
  </div>
);

export const BreakdownRow = ({ label, value, total, color }) => (
  <div className={Styles.breakdownRow}>
    <span className={Styles.breakdownLabel}>{label}</span>
    <div className={Styles.breakdownTrack}>
      <div
        className={Styles.breakdownFill}
        style={{ width: `${total ? Math.round((value / total) * 100) : 0}%`, backgroundColor: color }}
      />
    </div>
    <span className={Styles.breakdownValue}>{formatNumber(value)}</span>
  </div>
);

export const LeaderList = ({
  items = [],
  emptyText,
  valueLabel = "",
  onItemClick,
}) => {
  if (items.length === 0) {
    return <p className={Styles.emptyText}>{emptyText}</p>;
  }

  return (
    <ul className={Styles.topList}>
      {items.map((item, index) => {
        const content = (
          <>
            <span className={Styles.topRank}>{index + 1}</span>
            <span className={Styles.topInfo}>
              <span className={Styles.topTitle}>{item.name}</span>
              {item.meta && <span className={Styles.topMeta}>{item.meta}</span>}
            </span>
            <span className={Styles.topCount}>
              {formatNumber(item.value)} {item.valueLabel || valueLabel}
            </span>
          </>
        );

        return (
          <li
            key={item.id}
            className={`${Styles.topItem} ${
              onItemClick ? Styles.topItemClickable : ""
            }`}
          >
            {onItemClick ? (
              <button
                type="button"
                className={Styles.topItemButton}
                onClick={() => onItemClick(item)}
              >
                {content}
              </button>
            ) : (
              content
            )}
          </li>
        );
      })}
    </ul>
  );
};

export const SegmentTable = ({ segments = [] }) => (
  <div className={Styles.tableWrapper}>
    <table className={Styles.table}>
      <thead>
        <tr>
          <th>Segment</th>
          <th>Users</th>
          <th>Premium</th>
          <th>Conv.</th>
          <th>Locations</th>
          <th>Views</th>
        </tr>
      </thead>
      <tbody>
        {segments.map((segment) => (
          <tr key={segment.key}>
            <td>
              <span className={Styles.segmentLabel}>
                <span
                  className={Styles.segmentDot}
                  style={{ backgroundColor: segment.color }}
                />
                {segment.label}
              </span>
            </td>
            <td>{formatNumber(segment.users)}</td>
            <td>{formatNumber(segment.premium)}</td>
            <td>{segment.premiumRate}%</td>
            <td>{formatNumber(segment.locations)}</td>
            <td>{formatNumber(segment.views)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
